import get from 'lodash/get'
import has from 'lodash/has'
import Swal from 'sweetalert2'

const buildHtmlErrors = (errors) => {
    let htmlErrors = '<strong>There were some problems with your input.</strong><br>',
        firstField = '';

    Object.keys(errors).forEach((index) => {
        const value = errors[index]
        htmlErrors += '<br>' + (Array.isArray(value) ? value.join('<br>') : value);
        if (firstField == '') {
            firstField = index;
        }
    });

    return htmlErrors;
};

export function error (data) {
    if (!data) {
        return new Swal({
            title: 'Oops...',
            text: 'Looks like something went wrong. Please try again.',
            icon: 'error'
        });
    }

    if (typeof data === 'string') {
        return new Swal('Oops...', data, 'error');
    }

    if (
        (data.status && data.status == 422 && (has(data, 'body.errors') || has(data, 'responseJSON.errors'))) ||
        (has(data, 'response.status') && data.response.status == 422)
    ) {
        let errors = has(data, 'body.errors')
            ? data.body.errors
            : has(data, 'responseJSON.errors')
                ? data.responseJSON.errors
                : data.response.data.errors;

        return new Swal({
            title: '',
            html: buildHtmlErrors(errors),
            icon: 'error'
        });
    }

    if (has(data, 'body.message') || has(data, 'response.data.message')) {
        let message = has(data, 'body.exception') || has(data, 'response.data.exception')
            ? 'Looks like something went wrong. Please try again.'
            : (has(data, 'body.message') ? data.body.message : data.response.data.message);

        return new Swal({
            title: 'Oops...',
            text: message,
            icon: 'error'
        });
    }

    if (typeof data == 'object') {
        return new Swal({
            title: '',
            html: buildHtmlErrors(data),
            icon: 'error'
        });
    }

    return new Swal('Oops...', 'Looks like something went wrong. Please try again.', 'error');
}

export function success (message) {
    return new Swal({
        title: 'Success',
        text: message,
        icon: 'success',
        animation: window.enabledAnimations
    });
}

export function confirm (title, message) {
    return new Promise((resolve, reject) => {
        return new Swal({
            title: title === null ? '' : title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            animation: window.enabledAnimations
        }).then(response => {
            resolve(get(response, 'value') === true)
        }).catch(() => {
            resolve(false)
        })
    })
}

export function warning (title, message) {
    return new Swal({
        title: title === null ? '' : title,
        text: message,
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        closeOnConfirm: true,
        animation: window.enabledAnimations
    });
}

export default {
    error,
    success,
    confirm,
    warning
}
